/* eslint-disable no-undef */
/** is touch **/
function is_touch_device() {
  var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ')
  var mq = function (query) {
    return window.matchMedia(query).matches
  }
  if (
    'ontouchstart' in window ||
    (window.DocumentTouch && document instanceof DocumentTouch)
  ) {
    return true
  }
  var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('')
  return mq(query)
}

if (is_touch_device()) {
  $('body').addClass('isTouch')
} else {
  $('body').addClass('noTouch')
}
window.touchMove = false
$(document).on('touchmove', function () {
  window.touchMove = true
})
$(document).on('touchstart', function () {
  window.touchMove = false
})
